import { CasualTournamentDetails } from '@fantaz/shared/data-access/models';

export function getExperience(
  details?: CasualTournamentDetails | null,
): string | undefined {
  return details?.metadata?.experience || details?.game?.metadata?.experience;
}
